// extracted by mini-css-extract-plugin
export default {"card":"style_card__9Tgci","image":"style_image__LBVxj","details":"style_details__QE5-6"};